import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupTypeMicrodelivery } from '../../ngrx/model/group-type-microdelivery';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject(EnvironmentService);

  _baseUrl = '';

  get baseUrl() {
    if (!this._baseUrl) {
      this._baseUrl = this.environmentService.getGroupServiceBaseUrl('groups');
    }
    return this._baseUrl;
  }

  addPipelinesToGroup(groupId: any, requestBody: string[]) {
    return this.http.post<any[]>(`${this.baseUrl}/${groupId}/pipelines`, requestBody);
  }

  getGroupOfDelivery(deliveryGuid?: string): Observable<any> {
    deliveryGuid = deliveryGuid || this.environmentService.getDeliveryGuid();
    return this.http.get<any>(`${this.baseUrl}?groupKey=${deliveryGuid}`);
  }

  createGroup(group: any) {
    return this.http.post(`${this.baseUrl}`, group);
  }

  removePipelinesFromGroup(groupId: string, pipelineIds: string[]) {
    return this.http.post(`${this.baseUrl}/${groupId}/pipelines/remove`, pipelineIds);
  }

  getMicrodeliveriesByGroupId(groupId: string): Observable<GroupTypeMicrodelivery[]> {
    const requestUrl = `${this.baseUrl}/${groupId}/microdeliveries`;
    return this.http.get<GroupTypeMicrodelivery[]>(requestUrl);
  }

  updateMicrodeliveriesInGroup(microdeliveries: GroupTypeMicrodelivery[]): Observable<GroupTypeMicrodelivery[]> {
    const parentGroupId = this.environmentService.groupId;
    const requestUrl = `${this.baseUrl}/${parentGroupId}/microdeliveries/override`;
    return this.http.post<GroupTypeMicrodelivery[]>(requestUrl, microdeliveries);
  }

  addMicrodeliveriesToGroup(microdeliveries: GroupTypeMicrodelivery[]): Observable<GroupTypeMicrodelivery[]> {
    const parentGroupId = this.environmentService.groupId;
    const requestUrl = `${this.baseUrl}/${parentGroupId}/microdeliveries/add`;
    return this.http.post<GroupTypeMicrodelivery[]>(requestUrl, microdeliveries);
  }
}
